// Exports the "pagebreak" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/pagebreak')
//   ES2015:
//     import 'tinymce/plugins/pagebreak'
require('./plugin.js');


// WEBPACK FOOTER //
// ./src/packages/tinymce/plugins/pagebreak/index.js